import { Component, OnInit, Inject, Optional } from '@angular/core';
import { CandidateService } from 'src/app/shared/candidate.service';
import { ProcessService } from 'src/app/shared/process-service/process.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
export interface DialogData {
  candidateId: number;
  processName: string;
}
@Component({
  selector: 'app-candidate-details-modal',
  templateUrl: './candidate-details-modal.component.html',
  styleUrls: ['./candidate-details-modal.component.scss']
})
export class CandidateDetailsModalComponent implements OnInit {


  candidateId: number;
  candidateDetails: any;

  processName: string;
  feedbackMap = new Map();
  firstProcess: boolean = false;
  allProcesses = [];
  previousProcess = [];

  constructor(
    private candidateService: CandidateService,
    private processService: ProcessService,
    public dialogRef: MatDialogRef<CandidateDetailsModalComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public element: DialogData) {
    this.candidateId = element.candidateId;
    this.processName = element.processName;
  }

  ngOnInit() {
    this.getAssignedCandidateDetails();
    this.getAllProcess();
  }

  getAssignedCandidateDetails() {
    this.candidateService.findById(this.candidateId).then(
      candidateDetails => {

        this.candidateDetails = candidateDetails;

        for (let i = 0; i < candidateDetails.panelCandidates.length; i++) {
          if (candidateDetails.panelCandidates[i].processName != this.processName) {
            this.feedbackMap.set(candidateDetails.panelCandidates[i].processName, candidateDetails.panelCandidates[i].feedback);
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  getAllProcess() {
    this.processService.findAll().then(
      processes => {
        this.allProcesses = processes;

        // To find first process
        if(this.allProcesses[0].processName == this.processName){
          this.firstProcess = true;
        }
        // To maintain the order of processes scheduled
        for(let i = 0;i < processes.length ;i++){
          if(processes[i].processName !== this.processName){
            this.previousProcess.push(processes[i].processName);
          }else{
            break;
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  onClose() {
    this.dialogRef.close();
  }
}
